import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import { Device } from 'types';

export interface DeviceHealthMissingCardProps {
    device: Device;
}

export const DeviceHealthMissingCard = ({
    device,
}: DeviceHealthMissingCardProps) => {
    return (
        <Card data-testid="DeviceHealthMissingCard">
            <CardHeader title="No Health Data Available" />
            <CardContent>
                {device.virtual ? (
                    <span data-testid="DeviceHealthMissingCard-virtual">
                        Monitor health data is not available for {device.name} (
                        {device.customer_name}) because it is a virtual monitor.
                    </span>
                ) : (
                    <span data-testid="DeviceHealthMissingCard-physical">
                        There is no health data available for the {device.name}(
                        {device.customer_name}) monitor at this time.
                    </span>
                )}
            </CardContent>
        </Card>
    );
};
